import { Link } from 'gatsby';
import * as React from 'react';
import { useEffect } from 'react';
import { arrowDiagonalWhite } from '@images/chd-tv-icons';
import { SlugPrefix } from '@models/pages';
import ChdTvLogo from '../../images/chd-tv.svg';
import { GlobalContext } from '../GlobalContext';

interface Props {
  lang: string
  pathname: string
}

function LivePushDown({ lang, pathname }:Props) {
  const globalContext = React.useContext(GlobalContext);

  const handleClick = () => {
    if (globalContext) {
      globalContext.setExtendedPushDown(!globalContext.extendedPushDown);
      sessionStorage.setItem('extendedPushDown', (!globalContext.extendedPushDown).toString());
    }
  };

  useEffect(() => {
    const extendedPushDown = sessionStorage.getItem('extendedPushDown');
    if (extendedPushDown) {
      globalContext?.setExtendedPushDown(extendedPushDown === 'true');
    } else {
      globalContext?.setExtendedPushDown(true);
    }
  }, []);

  const liveItems = globalContext?.liveItems.filter((v) => v.imageUrl && v.slug);
  const isCurrentPageLive = liveItems?.map((item) => item.slug).includes(pathname);

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {(!!liveItems?.length && !isCurrentPageLive) && (
        <div className="bg-black p-[5px] leading-none">
          {globalContext?.extendedPushDown && (
          <div className="flex justify-center overflow-auto pb-[5px]">
            {liveItems.map((item) => (
              <Link to={item.slug} key={item.id}>
                <img className="w-[93px] xs:w-[115px] sm:w-[175px] m-[5px]" src={item.imageUrl} alt={item.title} />
              </Link>
            ))}
          </div>
          )}
          <div className="h-[32px] flex flex-row justify-center items-center font-serif text-white  xs:text-[14pt] text-[12pt] whitespace-nowrap">
            <p>
              Streaming
              {' '}
              <span className="text-chdGreen-light">Live</span>
              {' '}
              Now on
              {' '}
            </p>
            <Link to={`${lang === 'en' ? '' : `/${lang}`}${SlugPrefix.ChdTv}`} className="inline-block ml-[8px]">
              <img src={ChdTvLogo} className="h-[25px]" alt="sign up for show sms reminders" />
            </Link>
            <button onClick={handleClick} type="button" className="ml-[10px] self-center">
              <img src={arrowDiagonalWhite} className="h-[14px] xs:h-[14px]" alt="Expand streaming live menu" />
            </button>
          </div>
        </div>
      )}
    </>
  );
}

export default LivePushDown;
